export default __webpack_public_path__ + "02278f4fae2931b02a0685c68260d34b.png";